import { Fetch, Auth } from '@loca/mfe-utils'
import { getPath, getCommonParams, getAppGatewayPath } from '@/config/base'
import { FetchMonitorHook } from './fetchHooks'

export const BASE_API = `${getPath()}/powermap/h5`
// const BASE_API = `${getPath()}/app/api/pe/h5`;

// export const fetch = Fetch.genFetch(BASE_API, {
//   commonParams: getCommonParams(),
//   needAuth: true,
// })

export const fetch = new FetchMonitorHook(
  Fetch.genFetch(BASE_API, {
    commonParams: getCommonParams(),
    needAuth: true,
  })
)

export const fetchAppGateway = Fetch.genFetch(getAppGatewayPath(), {
  withTimestamp: false,
  commonParams: { ...getCommonParams(), app_id: undefined, hash_type: 'sha256' } as any,
})

export const setTokens = Auth.setTokens
export const getTokens = Auth.getAccessToken
